<div class="object-copy-section">
  <div class="object-copy-section__title">
    <mat-checkbox
      [checked]="isSectionSelected()"
      [indeterminate]="isSectionIndeterminate()"
      (change)="objectCopyService.toggleSection($event.checked, section())"
    >
      @if (!section().hide_title) {
        <app-object-view-section-title [title]="section().title" />
      }
    </mat-checkbox>
  </div>

  @for (field of copyableFields(); track field) {
    @if (isMediaField(field)) {
      <app-object-copy-media
        [field]="field"
        [section]="section()"
      />
    } @else {
      <app-object-copy-field
        [section]="section()"
        [field]="field"
      />
    }
  }
</div>
